module.exports = __webpack_public_path__ + "media/feature-icons/calculations-da964c3d.png";